import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import EvenementiellerPage from "../pages/evenementielle/page";
import InterieurPage from "../pages/interieur/page";
import Creation3DPage from "../pages/creation3d/page";
import ConseilPage from "../pages/conseil/page";
import ContactPage from "../pages/contact/page";
import AProposPage from "../pages/apropos/page";
import GalleryPage from "../pages/galerie/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/decoration-evenementielle",
    element: <EvenementiellerPage />,
  },
  {
    path: "/decoration-interieur",
    element: <InterieurPage />,
  },
  {
    path: "/creation-3d",
    element: <Creation3DPage />,
  },
  {
    path: "/conseil",
    element: <ConseilPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "/a-propos",
    element: <AProposPage />,
  },
  {
    path: "/galerie",
    element: <GalleryPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
